import { FC } from 'react';

import ContactSupportComponent from './components/ContactSupport';
import locales from './locales';

const ContactSupport: FC = () => (
  <ContactSupportComponent body={locales.body} title={locales.title} />
);

export default ContactSupport;
